import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ActionPayloadType } from 'app/area/link-codes/types-store';
import { connectType } from 'app/area/shared/codetable/constants';

interface ActiveTypeSettings {
  type: ActionPayloadType;
  node?: number;
}

export const getActiveType = (codetableId: number): ActiveTypeSettings => {

  if (isDefinedIncludingZero(connectType[codetableId])) {
    return {
      type: ActionPayloadType.type,
      node: connectType[codetableId]
    };
  }

  return { type: ActionPayloadType.userGroup };

};
